import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createBooth',
    serviceName: 'shopadmin',
    query: gql`
      mutation createBooth(
        $title: String!
        $code: String!
        $shop_id: String!
        $user_id: String!
        $is_active: Int
        $fee_value: String
        $fee_type_id: String
        $fee_ceiling: String
      ) {
        createBooth(
          title: $title
          code: $code
          shop_id: $shop_id
          user_id: $user_id
          is_active: $is_active
          fee_value: $fee_value
          fee_type_id: $fee_type_id
          fee_ceiling: $fee_ceiling
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
